export default __webpack_public_path__ + "static/media/complete_connect.033dc3ec.svg";